import assign from 'lodash/assign';

import constants from '../constants';

const initState = () => ({
  listings: [],
});

const moveInFeedback = (state = initState(), action = {}) => {
  const { type, payload } = action;

  if (type === constants.EDIT_LISTINGS) {
    return assign({}, state, {
      listings: payload,
    });
  } else {
    return state;
  }
};

export default moveInFeedback;
